export class KeyConnectorUserDecryptionOption {
  constructor(public keyConnectorUrl: string) {}
}
